<template>
  <a-drawer width="65%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <page-header-wrapper>
      <a-card :bordered="false">
        <!-- 条件搜索 -->
        <!-- 操作 -->
        <div class="table-operations">
          <a-button type="primary" @click="$refs.createForm.handleAdd(queryParam.competitionId,competitionType)">
            <a-icon type="plus" />新增
          </a-button>
          <table-setting
            :style="{float: 'right'}"
            :table-size.sync="tableSize"
            v-model="columns"
            :refresh-loading="loading"
            @refresh="getList" />
        </div>
        <!-- 增加修改 -->
        <create-form
          ref="createForm"
          @ok="getList"
        />
        <!-- 数据展示 -->
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :columns="columns"
          :data-source="list"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :pagination="false"
          :bordered="tableBordered"
        >

          <img style="width: 48px;height: 48px;" preview="头像" :src="record.userAvatar" v-if="record.userAvatar != null && record.userAvatar != ''" slot="userAvatar" slot-scope="text, record">

          <span slot="createTime" slot-scope="text, record">
            {{ parseTime(record.createTime) }}
          </span>
          <span slot="operation" slot-scope="text, record">
<!--            <a-divider type="vertical" v-hasPermi="['platform:competitionManage:edit']" />-->
<!--            <a @click="$refs.createForm.handleUpdate(record, undefined, competitionType)" v-hasPermi="['platform:competitionManage:edit']">-->
<!--              <a-icon type="edit" />修改-->
<!--            </a>-->
<!--            <a-divider type="vertical" v-hasPermi="['platform:competitionManage:remove']" />-->
            <a @click="handleDelete(record)">
              <a-icon type="delete" />删除
            </a>
          </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </a-card>
    </page-header-wrapper>
  </a-drawer>
</template>

<script>
import { pageCompetitionManage,listCompetitionManage, delCompetitionManage } from '@/api/platform/competitionManage'
import CreateForm from './modules/ManageCreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CompetitionManage',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      open: false,
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        competitionId: null,
        competitionType: null,
        userId: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '视决号',
          dataIndex: 'userNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用户昵称',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '类型',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender: function (value, record) {
            if (value == 1) {
              return "赛事管理员"
            }
            if (value == 2) {
              return "阶段管理员"
            }
          }
        },
        {
          title: '阶段',
          dataIndex: 'schedule',
          ellipsis: true,
          align: 'center',
          customRender: function (value, record) {
            if (value == 0) {
              return "全部"
            }
            if (value == 1) {
              return "初赛"
            }
            if (value == 2) {
              return "复赛"
            }
            if (value == 3) {
              return "决赛"
            }
          }
        },
        {
          title: '用户头像',
          dataIndex: 'userAvatar',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: "userAvatar"}
        },
        {
          title: '年龄',
          dataIndex: 'age',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '学校名称',
          dataIndex: 'schoolName',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
   // this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    /** 修改按钮操作 */
    show (row) {
      this.queryParam.competitionId = row.id;
      this.competitionType = row.type;
      this.open = true
      this.getList();
    },
    /** 查询赛事管理列表 */
    getList () {
      this.loading = true
     pageCompetitionManage(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        competitionId: undefined,
        userId: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delCompetitionManage(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('platform/competition-manage/export', {
            ...that.queryParam
          }, `赛事管理_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
